import { useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { ChatPageMessageListQueryKeys } from '@enums/react-query-keys';
import { getMessagesByPagination } from '@api/notifications';
import useUser from '@hooks/user/use-user';

const useMessageList = (limit: number) => {
  const { user } = useUser();

  const { data, isFetching, isFetchingNextPage, fetchNextPage, hasNextPage } = useInfiniteQuery({
    queryKey: [ChatPageMessageListQueryKeys.CHAT_PAGE_MSG_LIST, user?.id],
    queryFn: ({ pageParam = 0 }) => getMessagesByPagination(pageParam, limit),
    getNextPageParam: (lastPage) => {
      if (lastPage?.meta?.count < limit) {
        return undefined;
      }
      return lastPage.data.length > 0 ? lastPage?.meta?.count + lastPage?.meta?.offset : undefined;
    },
  });
  const messages = useMemo(() => data?.pages.reduce((t, c) => t.concat(c.data), []), [data]);

  return {
    data: messages || [],
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  };
};

export default useMessageList;
